<template>
  <div class="efooter">
    Copyright @ 2024 二一教育技术部出品 版本号@ {{AppVersion}}
  </div>
</template>

<script>
export default {
  name: 'LayoutFooter'
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

.efooter {
  margin: 48px 0 24px;
  text-align: center;
}

</style>


// WEBPACK FOOTER //
// src/views/layouts/LayoutFooter.vue